import React from "react";
import { NavItem, NavLink, Badge, Collapse, DropdownItem } from "shards-react";

const Notifications = ({noti, clickNoti}) => {
    return (
      <NavItem className="border-right dropdown notifications" style={{cursor:"pointer"}}>
        <NavLink
          className="nav-link-icon text-center"
          onClick={clickNoti}
        >
          <div className="nav-link-icon__wrapper">
            <i className="material-icons">&#xE7F4;</i>
            <Badge pill theme="danger">
              2
            </Badge>
          </div>
        </NavLink>
        <Collapse
          open={noti}
          className="dropdown-menu dropdown-menu-small"
        >
          <DropdownItem>
            <div className="notification__icon-wrapper">
              <div className="notification__icon">
                <i className="material-icons">&#xE6E1;</i>
              </div>
            </div>
            <div className="notification__content">
              <span className="notification__category">아직 구현 전입니다.</span>
              <p>
                아직 구현되지 않았습니다. {" "}
                <span className="text-success text-semibold">곧</span> 추가 될 예정입니다.
              </p>
            </div>
          </DropdownItem>
          <DropdownItem>
            <div className="notification__icon-wrapper">
              <div className="notification__icon">
                <i className="material-icons">&#xE8D1;</i>
              </div>
            </div>
            <div className="notification__content">
              <span className="notification__category">아직 구현 전입니다.</span>
              <p>
                아직 구현되지 않았습니다. {" "}
                <span className="text-danger text-semibold">곧</span> 추가 될 예정입니다.
              </p>
            </div>
          </DropdownItem>
          <DropdownItem className="notification__all text-center">
            View all Notifications
          </DropdownItem>
        </Collapse>
      </NavItem>
    );
    }

export default Notifications;